import { application } from "./application"
import NestedFormController from "./nested_form_controller"
import FavoriteController from "./favorite_controller"
import LoadingFormController from "./loading_form_controller"

application.register("nested-form", NestedFormController)
application.register("favorite", FavoriteController)
application.register("loading-form", LoadingFormController)